import {MouseEvent} from "react";

import {PropertyPlanIcon} from "@pg-design/icons-module";

interface IOwnProps {
    onPlanClick: (e: MouseEvent<HTMLElement>, index: number) => void;
    index: number;
}

export const PropertyListPlanButton = (props: IOwnProps) => {
    const {onPlanClick, index} = props;

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onPlanClick(e, index);
    };

    return (
        <span onClick={handleClick} data-interactive style={{cursor: "pointer", display: "inline-flex"}}>
            <PropertyPlanIcon size="2" aria-label="Zobacz plan" />
        </span>
    );
};
import {MouseEvent} from "react";

import {PropertyPlanIcon} from "@pg-design/icons-module";

interface IOwnProps {
    onPlanClick: (e: MouseEvent<HTMLElement>, index: number) => void;
    index: number;
}

export const PropertyListPlanButton = (props: IOwnProps) => {
    const {onPlanClick, index} = props;

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onPlanClick(e, index);
    };

    return (
        <span onClick={handleClick} data-interactive style={{cursor: "pointer", display: "inline-flex"}}>
            <PropertyPlanIcon size="2" aria-label="Zobacz plan" />
        </span>
    );
};
